import { ColDef } from "ag-grid-community";
import { columnDefinitions } from "./columnDefinitions";

// Simple-mode positions columns: reuse existing, remove Book, ensure key metrics are visible
export const simplePositionsColumnDefinitions: ColDef[] = (columnDefinitions as ColDef[])
  .filter((col: any) => col.field !== "book")
  .map((col: ColDef) => {
    if (col.field === "price") {
      return { ...col, hide: false } as ColDef; // Market Price
    }
    if (col.field === "costBasis") {
      return { ...col, hide: false } as ColDef; // Cost Basis
    }
    // if (col.field === "returnOnPremium") {
    //   return { ...col, hide: false } as ColDef; // Return On Premium
    // }
    if (col.field === "strategy") {
      return { ...col, hide: false } as ColDef; // Strategy
    }
    return col;
  });


